import '../App.css';

function MainContent(){
    return(
          <div className="content">         
          <h1>Main Content</h1>
          <p>Click the menu button to open the sidebar.</p>
      </div>)
}

export default MainContent;